import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useEffect, useRef, useState } from "react";
import { SortOrder } from "primereact/api";
import findFaturamento from "../../service/findFaturamento";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import { carregarFranquias } from "../../hooks/useFranquias";
import { Dropdown } from "primereact/dropdown";
import { Messages } from "primereact/messages";


export default function FaturamentoCadastrar({onClose, onSave}:{onClose: () => void, onSave: (faturamneto:any) => void}) {
  const { t } = useTranslation();
  const {state} = useGlobalState();
  const msgs = useRef<Messages>(null);
  const [selectedFranquia, setSelectedFranquia] = useState<any>(null);
  const [franquias, setFranquias] = useState<any>([]);
  const [data, setData] = useState<any>(null); 
  
  const defaultValues = {
    dataReferencia: null,
    dataInicio: null,
    dataFim: null,
    dataVencimento: null
  };
 
  
  const {
      control,
      formState: { errors},
      handleSubmit,
      setValue
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.dataReferencia && save(data);
  };

  const valid = (fat:any) => {
    if(fat.dataInicio > fat.dataFim){
      if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Data fim deve ser maior que data início', closable: false }
              
          ]);
        }
      return false;
    }
    return true;
  }
 
  const save = (data:any) => {
    const fat = {
      dataReferencia:data.dataReferencia,
      dataInicio:data.dataInicio,
      dataFim:data.dataFim,
      dataVencimento:data.dataVencimento,
      idFranquia: selectedFranquia?.id
    }
    window.scrollTo(0, 0);
    if(valid(fat)){
      onSave(fat);
    }
    
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  useEffect(() => {
    const lazy = {
        first: 0,
        rows: 999999999,
        page: 1,
        data: null,
        status: null,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'dataFim',
        sortOrder: SortOrder.DESC
    };
    findFaturamento(lazy).then(data => {
      if(data && data.faturamentos.length > 0){
        const dataInicio = data.faturamentos[0].dataFim;
        dataInicio.setDate(dataInicio.getDate() + 1);
        setValue('dataInicio',dataInicio);
        setData(dataInicio)
      }
      
    });
    carregarFranquias().then(lista => {
      lista.forEach( (c: { nome: string; id: string; }) => {

        if(state.user.franquiaSelected && c.nome === state.user.franquiaSelected.nome){
          setSelectedFranquia(c)
        }
      })
      setFranquias(lista);
    })
  }, [])

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
        <Messages ref={msgs} />
          <div className="grid">
              <div className="col ">
                
                  <Controller
                      name="dataReferencia"
                      control={control}
                      rules={{ required: 'Data Referência é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataReferencia })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="dataReferencia" className="font-bold block mb-2 required">{t('dataReferencia')} </label>
                                <Calendar maxDate={new Date()} id='data' value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="mm/yy" locale='pt'/>
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              <div className="col">
                <Controller
                      name="dataVencimento"
                      control={control}
                      rules={{ required: 'Data Vencimento é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataVencimento })}></label>
                              <span className="">
                              <div>
                              <label htmlFor="dataVencimento" className="font-bold block mb-2 required">{t('dataVencimento')} </label>
                              <Calendar minDate={new Date()} id='data' value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          <div className="grid">
              <div className="col">
                
                  <Controller
                      name="dataInicio"
                      control={control}
                      rules={{ required: 'Data Início é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataInicio })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="dataInicio" className="font-bold block mb-2 required">{t('dataInicio')} </label>
                                <Calendar disabled={data} id='dataInicio' value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              <div className="col">
                <Controller
                      name="dataFim"
                      control={control}
                      rules={{ required: 'Data Fim é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataFim })}></label>
                              <span className="">
                              <div>
                              <label htmlFor="dataFim" className="font-bold block mb-2 required">{t('dataFim')} </label>
                              <Calendar id='dataFim' minDate={data}  maxDate={new Date()} value={field.value}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          {!state.user.franquia && (
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <label className="label-dados" style={{paddingLeft:'0'}}>{t('franquia')}</label>
                  <Dropdown disabled ={state.user.franquiaSelected} style={{width: '50%'}} value={selectedFranquia} onChange={(e) => setSelectedFranquia(e.value)} options={franquias} optionLabel="nome" 
                      placeholder="Selecione" className="md:w-14rem" />
                </div>
            </div>
          )}            
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}

